module.exports = require('./lib/heap');



//////////////////
// WEBPACK FOOTER
// ./~/heap/index.js
// module id = 1847
// module chunks = 0